export default "__VITE_ASSET__CUPq35c5__"